import { AdminTemplate, CurrentBalanceListFilter } from "../../components";
export const CurrentBalanceList = () => {
  return (
    <AdminTemplate
      headerProps={{
        hideAddButton: true,
        headerTitle: "Cari Bakiye Listesi",
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={true}>
      <CurrentBalanceListFilter />
    </AdminTemplate>
  );
};